/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TicketSubsidyLogDto } from '../../models/ticket-subsidy-log-dto';

export interface TicketSubsidyControllerDeleteTicketSubsidy$Params {
  id: string;
}

export function ticketSubsidyControllerDeleteTicketSubsidy(http: HttpClient, rootUrl: string, params: TicketSubsidyControllerDeleteTicketSubsidy$Params, context?: HttpContext): Observable<StrictHttpResponse<TicketSubsidyLogDto>> {
  const rb = new RequestBuilder(rootUrl, ticketSubsidyControllerDeleteTicketSubsidy.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TicketSubsidyLogDto>;
    })
  );
}

ticketSubsidyControllerDeleteTicketSubsidy.PATH = '/api/ticket-subsidy/{id}';
